<span
  class="text-sm font-semibold"
  [ngClass]="{
    'opacity-40': disabled(),
  }"
  >{{ label() }}</span
>
<div
  class="flex justify-center items-center rounded-radius-circle bg-action-primary"
  [ngClass]="{
    'drop-shadow-status-success-shadow-30 w-[32px] h-[32px]': type() === 'primary',
    'w-[24px] h-[24px]': type() === 'secondary',
    'opacity-40': disabled(),
  }"
>
  <svg-icon size="16" key="arrow-link-16" class="text-foreground-secondary-100 dark:text-foreground-primary-100"></svg-icon>
</div>
